var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComponent4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1999 0.699951C5.23523 0.699951 0.399902 5.53528 0.399902 11.5C0.399902 17.4646 5.23523 22.3 11.1999 22.3C17.1646 22.3 21.9999 17.4646 21.9999 11.5C21.9999 5.53528 17.1646 0.699951 11.1999 0.699951ZM5.58457 9.64502H8.03209V16.9988H5.58457V9.64502ZM8.19343 7.37016C8.17755 6.64913 7.66194 6.09995 6.82466 6.09995C5.98738 6.09995 5.43999 6.64913 5.43999 7.37016C5.43999 8.07626 5.9712 8.64126 6.79288 8.64126H6.80853C7.66194 8.64126 8.19343 8.07626 8.19343 7.37016ZM14.0409 9.47231C15.6514 9.47231 16.8589 10.5236 16.8589 12.7823L16.8588 16.9988H14.4114V13.0645C14.4114 12.0763 14.0572 11.402 13.1712 11.402C12.495 11.402 12.0922 11.8566 11.9153 12.2956C11.8506 12.453 11.8347 12.6722 11.8347 12.892V16.999H9.38694C9.38694 16.999 9.4192 10.3352 9.38694 9.64519H11.8347V10.6868C12.1596 10.1861 12.7414 9.47231 14.0409 9.47231Z",
    fill: "#ADADAE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent4);
export default __webpack_public_path__ + "static/media/Component 4.9baab374be57c7acb431e5ce114fa0a5.svg";
export { ForwardRef as ReactComponent };